import { useMemo } from "react";

type DeviceType = "mobile" | "tablet" | "tv" | "desktop";

const detectDeviceType = (): DeviceType => {
  const ua = navigator.userAgent.toLowerCase();
  if (/smart[- ]?tv|smarttv|tizen|hbbtv|netcast|appletv|googletv|roku|firetv|aft/i.test(ua)) {
    return "tv";
  }
  if (/ipad|tablet|kindle|playbook/i.test(ua)) {
    return "tablet";
  }
  if (/mobi|iphone|ipod|android.*mobile|windows phone/i.test(ua)) {
    return "mobile";
  }

  return "desktop";
};

export const useGADeviceType = (): DeviceType => {
  return useMemo(() => detectDeviceType(), []);
};